import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
import { login, logout, getInfo,loginByphone,getStyleList } from '@/api/login';
import { getToken, setToken, removeToken } from '@/utils/auth';

//初始化时用sessionStore.getItem('token'),这样子刷新页面就无需重新登录
const state = {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    permissions: [],
    currentActiveMenu: ''
  };

const mutations = {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_KEY: (state, obj) => {
      state[obj.key] = obj.value
    }
    // SET_ROLES: (state, roles) => {
    //   state.roles = roles
    // },
    // SET_PERMISSIONS: (state, permissions) => {
    //   state.permissions = permissions
    // }
  };

const actions = {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.phone0.trim();
      const password = userInfo.password0;
      const code = userInfo.code;
      const uuid = userInfo.uuid;
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid).then(res => {
          if(res.data != '2001'){
            setToken(res.token)
            commit('SET_TOKEN', res.token)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginByphone({ commit }, userInfo) {
      //
      const phone = userInfo.phone.trim()
      const password = userInfo.passwordSet
      const code = userInfo.verifyCode
      return new Promise((resolve, reject) => {
        loginByphone(phone, password,code).then(res => {
          //
          setToken(res.token)
          commit('SET_TOKEN', res.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(res => {
          //
          const user = res.user
          const avatar = user.avatar == "" ? require("@/assets/images/profile.jpg") : process.env.VUE_APP_BASE_API + user.avatar;
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            // commit('SET_ROLES', res.roles)
            // commit('SET_PERMISSIONS', res.permissions)
          } else {
            // commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_NAME', user.userName)
          commit('SET_AVATAR', avatar)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          // commit('SET_ROLES', [])
          // commit('SET_PERMISSIONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  };

export default new Vuex.Store({
    state,
    mutations,
    actions
});



// WEBPACK FOOTER //
// ./src/store/index.js